export default {
  title: 'REALGAME Online Battle',
  locale: 'ja',
}
